import { CSSProperties } from 'react'

export const s = {
  wrapper: {
    width: '100%',
    marginTop: 55,
    display: 'flex',
    justifyContent: 'center',
  } as CSSProperties,
  root: {
    maxWidth: 600,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    gap: 30,
  } as CSSProperties,
  text: {
    fontSize: 32,
    lineHeight: '38px',
    color: 'black',
  } as CSSProperties,
}
